import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ManagedocumentsComponent } from '../managedocuments/managedocuments.component';
import { SaveDraftDialogComponent } from '../save-draft-dialog/save-draft-dialog.component';
type SaveDraftResult = 'yes' | 'no' | 'cancel' | undefined;

@Injectable({ providedIn: 'root' })
export class PendingChangesGuard implements CanDeactivate<ManagedocumentsComponent> {
  constructor(private readonly dialog: MatDialog,private readonly router: Router ) { }

  canDeactivate(component: ManagedocumentsComponent): Observable<boolean> | boolean {

    const navigation = this.router.getCurrentNavigation();
    const isDraftSave = navigation?.extras?.state?.['isDraftSave'];

    if (isDraftSave) {
      return true;
    }
    if ((component as any).isSubmitted) {
      return true;
    }

    if (!component.hasUnsavedChanges?.()) {
      return true;
    }

    const dialogRef = this.dialog.open(SaveDraftDialogComponent, {
      width: '600px',
      disableClose: true,
    });

    return dialogRef.afterClosed().pipe(
      map((result: SaveDraftResult) => {
        if (result === 'yes') {
          component.saveDraft();
          return true;
        }
        if (result === 'no') {
          return true;
        }
        // cancel or closed without choice
        return false;
      })
    );
  }
}
